import { Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  template: ''
})
export abstract class DestroyableComponent implements  OnDestroy {

  abstract toBeDestory$: Subject<void>;

  ngOnDestroy(): void {
    if(this.toBeDestory$){
      this.toBeDestory$.next();
      this.toBeDestory$.complete();
    }
  }
}